import styled from 'styled-components'

import theme from 'theme_'

export const Container = styled.div<{ borderColor?: string; bgColor?: string }>`
  --borderColor: ${({ borderColor }) =>
    borderColor || theme.colors.horizonOrange};
  --bgColor: ${({ bgColor }) => bgColor || theme.colors.white};

  display: flex;
  height: fit-content;
  .react-toggle-track {
    height: 22px;
    width: 36px;
    background-color: var(--bgColor);
    border: 1px solid var(--borderColor);
  }

  .react-toggle-thumb {
    width: 18px;
    height: 18px;
    border: 0;
    background-color: var(--borderColor);
    left: 2px;
    margin-top: 1px;
  }

  .react-toggle--checked .react-toggle-thumb {
    left: 16px;
    background-color: var(--bgColor);
  }

  .react-toggle:hover:not(.react-toggle--disabled) .react-toggle-track {
    background-color: var(--bgColor);
  }

  .react-toggle--checked:hover:not(.react-toggle--disabled)
    .react-toggle-track {
    background-color: var(--borderColor);
  }

  .react-toggle--checked .react-toggle-track {
    background-color: var(--borderColor);
  }

  .react-toggle:active:not(.react-toggle--disabled) .react-toggle-thumb {
    box-shadow: 0px 0px 2px 2px ${theme.colors.darkeyGrey};
  }

  .react-toggle:active:not(.react-toggle--disabled) .react-toggle-thumb {
    box-shadow: 0px 0px 2px 2px ${theme.colors.darkeyGrey};
  }

  .react-toggle--focus .react-toggle-thumb {
    box-shadow: 0px 0px 2px 1px ${theme.colors.darkeyGrey};
  }
`

export const StyledToggleLabel = styled.label`
  margin-left: ${theme.spacing.base};
`
